import type { IColumn } from 'types'

import { routes } from 'helpers/routes'
import { Breadcrumb } from 'recoils/atoms'

export const HEADERS: IColumn[] = [
  {
    key: 'checkbox',
    label: '',
    sortable: false,
    width: 5,
  },
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 5,
  },
  {
    key: 'code',
    label: 'productCategory:header.code.label',
    sortable: true,
    width: 15,
  },
  {
    key: 'nameTh',
    label: 'productCategory:header.name.label',
    sortable: true,
    width: 30,
  },
  {
    key: 'detail',
    label: 'productCategory:header.detail.label',
    sortable: true,
    width: 30,
  },
  {
    key: 'isActive',
    label: 'common:header.status.label',
    sortable: true,
    width: 15,
  },
]

export const BREADCRUMBS_LIST: Breadcrumb[] = [
  {
    key: routes.productCategory.path,
    label: 'layout:productCategoryManagement.breadcrumb',
  },
]

export const BREADCRUMBS_CREATE: Breadcrumb[] = [
  {
    key: routes.productCategory.path,
    label: 'layout:productCategoryManagement.breadcrumb',
  },
  {
    key: routes.productCategory.create.path,
    label: 'layout:createProductCategory.breadcrumb',
  },
]

export const BREADCRUMBS_EDIT: Breadcrumb[] = [
  {
    key: routes.productCategory.path,
    label: 'layout:productCategoryManagement.breadcrumb',
  },
  {
    key: routes.productCategory.create.path,
    label: 'layout:editProductCategory.breadcrumb',
  },
]
